import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=117b39f6&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"
import style0 from "./PatientList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PatientList.vue?vue&type=style&index=1&id=117b39f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117b39f6",
  null
  
)

export default component.exports